export const ReportStudioPathName = {
  REPORTSTUDIO: 'reportstudio',
  REPORTSTUDIO_TEMPLATES: 'reportstudio:templates',
};

export const ExportBuilderNewReportContext = {
  DASHBOARD: 'ExportBuilderNewReportContext:DASHBOARD',
  REPORTSTUDIO: 'ExportBuilderNewReportContext:REPORTSTUDIO',
};

export const ExportBuilderAdminNewReportModalConstants = {
  MODAL_ID: 'new-report-modal',
};

export const PageSpecifications = {
  WIDTH: 1360, // arbitrary size
  RATIO: 110 / 85, // Letter page ratio
  INNER_MARGINS: 1, // % of the height or width
  BOTTOM_MARGIN: 40, // margin between each page, in px
};

export const PageAspectRatio = {
  STANDARD: 110 / 85, // Letter Page Ratio
  WIDESCREEN: 177 / 100,
};

export const PageFormat = {
  STANDARD: 'standard',
  WIDESCREEN: 'widescreen',
};

export const ReportTemplateType = {
  TYPE_CUSTOM: 'custom',
  TYPE_DATA: 'data',
  TYPE_REPORT: 'report',
  TYPE_DESIGN: 'design',
};

export const PageOrientation = {
  TYPE_LANDSCAPE: 'landscape',
  TYPE_PORTRAIT: 'portrait',
};

export const PageGridConstants = {
  RATIO: 85 / 110,
  X: 48,
  Y: 48,
  MINIMUM_PIXEL_HEIGHT: 20,
  MINIMUM_PIXEL_WIDTH: 20,
};

export const ExportBuilderPanelConstants = {
  RATIO: 85 / 110,
  X: 60,
  Y: 48,
  MINIMUM_PIXEL_HEIGHT: 20,
  MINIMUM_PIXEL_WIDTH: 20,
};

export const ExportType = {
  TYPE_EXPORT_PDF: 'export_pdf',
  TYPE_EXPORT_PPT: 'export_ppt',
  TYPE_EXPORT_SLIDES: 'export_slides',
  TYPE_SCHEDULED_REPORT_PDF: 'scheduled_report_pdf',
};

export const ExportBuilderDashboardConstants = {
  DELAY_REPORT: 1000,
};

export const ZIndexProps = {
  BASE: 1, // lowest z-index
  STEP: 1, // step between each z-index
};

export const ExportBuilderPrefixes = {
  WIDGETID: 'widgetID-',
  TEMP_WIDGET_ID: 'tempWidgetID-',
  ITEMID: 'itemID-',
};

export const ReportElementType = {
  WIDGET: 'item-type-widget',
  IMAGE: 'item-type-image',
  SHAPE: 'item-type-shape',
  ICON: 'item-type-icon',
  TEXT: 'item-type-text',
  COLOR: 'item-type-color',
  MACRO: 'item-type-macro',
};

export const ReportElementMacroType = {
  DATE_RANGE: 'macro-date-range',
  COMPANY_LOGO: 'macro-company-logo',
  RECIPIENT_NAME: 'macro-recipient-name',
  PAGE_TITLE: 'macro-page-title',
  PAGE_NUMBER: 'macro-page-number',
  CREATED_ON: 'macro-created-on',
};

export const PageLayerPanel = {
  WIDTH: 250,
};

// The page grid is 100 units wide with 2-unit margins on each side, giving 96 usable units.
export const GRID_WIDTH = 96;

export const ReportElementShapeTypes = {
  // Legacy CSS shapes
  SQUARE: 'shape-square',
  CIRCLE: 'shape-circle',
  // SVG polygon shapes
  RIGHT_TRIANGLE: 'shape-right-triangle',
  POLYGON: 'shape-polygon',
  PARALLELOGRAM: 'shape-parallelogram',
  TRAPEZOID: 'shape-trapezoid',
  PLUS: 'shape-plus',
  // SVG arrow shapes
  ARROW_RIGHT: 'shape-arrow-right',
  ARROW_LEFT: 'shape-arrow-left',
  ARROW_UP: 'shape-arrow-up',
  ARROW_DOWN: 'shape-arrow-down',
  DOUBLE_ARROW: 'shape-double-arrow',
  // SVG line
  LINE: 'shape-line',
};

// Shape types rendered via CSS (legacy) — all others use SVG
export const CssShapeTypes = new Set(['shape-square', 'shape-circle']);

export const ShapeDefaultProps = {
  BORDER_RADIUS_SQUARE: '5%',
  BORDER_RADIUS_CIRCLE: '50%',
  WIDTH: 250,
  HEIGHT: 250,
  X_POSITION: 100,
  Y_POSITION: 100,
  LINE_HEIGHT: 20,
  DEFAULT_STROKE_WIDTH: 3,
};

export const BuilderPanel = {
  WIDTH: 420,
  ROW_HEIGHT: 30,
  STATIC_PANE_HEIGHT: 320,
  STATIC_PANE_HEADER_HEIGHT: 26,
};

export const ReportElementBaseOption = {
  MIRROR_X: 'mirror_x',
  MIRROR_Y: 'mirror_y',
  OPACITY: 'opacity',
  BACKGROUND_COLOR: 'background_color',
  BORDER_RADIUS: 'border_radius',
  SHADOW_COLOR: 'shadow_color',
  SHADOW_BLUR: 'shadow_blur',
  SHADOW_X: 'shadow_x',
  SHADOW_Y: 'shadow_y',
  BORDER_COLOR: 'border_color',
  BORDER_WIDTH: 'border_width',
  BORDER_TYPE: 'border_type',
  BORDER_OPACITY: 'border_opacity',
  ROTATE: 'rotate',
};

export const PageProperty = {
  BACK: 'Back',
  COVER: 'Cover',
};

export const ReportElementDesignOptions = {
  SHOW_ON_EVERY_PAGE: 'show_on_every_page',
  SHOW_ON_EVER_PAGE: 'show_on_every_page',
};

export const ReportElementIconDesignOptions = {
  ICON_COLOR: 'icon_color',
};

export const ReportElementShapeDesignOptions = {
  BORDER_RADIUS: 'border_radius',
  BACKGROUND_COLOR: 'background_color',
  STROKE_COLOR: 'stroke_color',
  STROKE_WIDTH: 'stroke_width',
  CORNERS: 'corners',
  INNER_RADIUS: 'inner_radius',
};

export const ReportElementLineDesignOptions = {
  LINE_STYLE: 'line_style',
  LINE_START_CAP: 'line_start_cap',
  LINE_END_CAP: 'line_end_cap',
};

export const ReportElementLineStyle = {
  SOLID: 'solid',
  DASHED: 'dashed',
  DOTTED: 'dotted',
  LONG_DASH: 'long_dash',
  DASH_DOT: 'dash_dot',
};

export const ReportElementLineCap = {
  NONE: 'none',
  CIRCLE: 'circle',
  ARROW: 'arrow',
  SQUARE: 'square',
};

export const ReportElementImageDesignOptions = {
  FILL_MODE: 'fill_mode',
};

export const ReportElementImageSupportedFillMode = {
  ASPECT_FIT: 'aspect_fit',
  ASPECT_FILL: 'aspect_fill',
  STRETCH: 'stretch',
};

export const ReportPageDesignOptions = {
  BACKGROUND_COLOR: 'background_color',
  OPACITY: 'opacity',
};

export const ReportElementTextDesignOption = {
  TEXT_TITLE: 'text',
  TEXT_ALIGNMENT: 'text_align',
  VERTICAL_ALIGNMENT: 'vertical_alignment',
  FONT_SIZE: 'font_size',
  FONT_FAMILY: 'font_family',
  FONT_STYLE: 'font_style',
  FONT_WEIGHT: 'font_weight',
  TEXT_PADDING: 'text_padding',
  TEXT_COLOR: 'text_color',
  TEXT_BOLD: 'text_bold',
  TEXT_ITALIC: 'text_italic',
  TEXT_UNDERLINE: 'text_underline',
  TEXT_STRIKETHROUGH: 'text_strikethrough',
  TEXT_OPACITY: 'text_opacity',
  TEXT_SHADOW_COLOR: 'text_shadow_color',
  TEXT_SHADOW_BLUR: 'text_shadow_blur',
  TEXT_SHADOW_X: 'text_shadow_x',
  TEXT_SHADOW_Y: 'text_shadow_y',
  TEXT_EMPTY_PLACEHOLDER: 'Title',
  HTML_TEXT: 'html_text',
};

export const ReportElementDesignOption = {
  TEXT_ALIGNMENT: {
    LEFT: 'left',
    RIGHT: 'right',
    CENTER: 'center',
    JUSTIFY: 'justify',
  },
  VERTICAL_ALIGNMENT: {
    TOP: 'flex-start',
    CENTER: 'center',
    BOTTOM: 'flex-end',
  },
  BORDER_TYPE: {
    SOLID: 'solid',
    DASHED: 'dashed',
    DOTTED: 'dotted',
    DOUBLE: 'double',
    GROOVE: 'groove',
    RIDGE: 'ridge',
    INSET: 'inset',
    OUTSET: 'outset',
  },
  BORDER_TYPE_VALUES: ['solid', 'dashed', 'dotted', 'double', 'groove', 'ridge', 'inset', 'outset'],
  FONT_SIZE_VALUES: Array.from(Array(143), (v, i) => `${i + 8}`),
  FONT_FAMILY_VALUES: [
    'Arial',
    'Arial Black',
    'Century Gothic',
    'Comic Sans MS',
    'Courier New',
    'Helvetica',
    'Impact',
    'Lato',
    'Lucida Grande',
    'Tahoma',
    'Times New Roman',
    'Verdana',
    'Roboto Light',
    'Roboto Regular',
    'Roboto Black',
    'Playfair Display Black',
  ],
  CUSTOM_FONT_FAMILY_VALUES: [
    'IBM Plex Sans',
    'IBM Plex Serif',
    'Proxima Nova',
    'Proxima Nova Light',
    'Proxima Nova Medium',
    'Proxima Nova Semibold',
    'Proxima Nova Thin',
    'Lexend',
    'Inter Tight',
    'Inter Tight Light',
    'Inter Tight Medium',
    'Inter Tight Semibold',
    'Inter Tight Bold',
    'Poppins',
    'Raleway',
  ],
};

export const ReportElementTableDesignOptions = {
  TABLE_ROWS: 'table_rows',
  TABLE_COLUMNS: 'table_columns',
  TEXT_TITLE: 'text',
  TABLE_DATA: 'table_data',
  TABLE_HEADERS: {
    ITEM: 'Item',
    PRICE: 'Price',
    QUANTITY: 'Quantity',
    SUB_TOTAL: 'Sub-Total',
    TOTAL: 'Total',
  },
};

export const MenuType = {
  PAGE: 'page',
  PAGE_PREVIEW: 'page_preview',
  ELEMENT: 'element',
};

export const ReportHeaderEvents = {
  OVERLAY_DISABLED: 'overlay_disabled',
};

export const ReportStudioPageEvent = {
  DELETE_PAGE_ERROR: 'delete_page_error',
  PAGE_DOUBLE_CLICK: 'page_double_click',
};

export const FontSize = {
  SIZE_SMALL: 'small',
  SIZE_MEDIUM: 'medium',
  SIZE_LARGE: 'large',
};

export const ReportStudioSyncServiceThreshold = {
  SKIP_PENDING_ELEMENTS_SAVE_THRESHOLD: 1000,
  SAVE_REPORT_THRESHOLD: 500,
};

export const PageMenuEvent = {
  CLICK: 'PageMenuEvent:CLICK',
};

export const BuilderEvents = {
  ZOOM_CALCULATED: '$BuilderEvents:ZOOM_CALCULATED',
  SHOW_MASK: 'show_mask',
};
export const ReportElementSetting = {
  SET_AS_BACKGROUND: 'set_as_background',
  SNAP_TO_GRID: 'snap_to_grid',
  IS_HIDDEN: 'is_hidden',
  SHOW_ON_EVERY_PAGE: 'show_on_every_page',
};

export const ReportStudioElementEvent = {
  ON_ELEMENT_OUTSIDE_CLICK: 'on_element_outside_click',
};

export const ReportStudioElementDrag = {
  DEFAULT_DRAG_VALUE: 260,
};

export const CanvasOptionsEvent = {
  TOGGLE_GRID: 'toggle_grid',
  TOGGLE_OUTLINE: 'toggle_outline',
  PRESENTATION_MODE: 'presentation_mode',
  TOGGLE_OVERFLOW: 'toggle_overflow',
  TOGGLE_FIT_VIEWPORT: 'toggle_fit_viewport',
};

export const ReportStudioRoute = {
  REPORTSTUDIO: 'reportstudio',
  REPORTS: 'reports',
  NUI_REPORTSTUDIO: 'nui/reportstudio',
  FAV_REPORTSTUDIO: 'fav/reportstudio',
  FAV_NUI_REPORTSTUDIO: 'fav/nui/reportstudio',
};

export const ReportStudioTemplateTab = {
  REPORTS: ReportStudioRoute.REPORTS,
  DESIGNS: 'designs',
};

export const DragResizeEvent = {
  ACTIVATED: 'activated',
  DEACTIVATED: 'deactivated',
  RESIZE_START: 'resizestart',
  RESIZING: 'resizing',
  RESIZE_STOP: 'resizestop',
  DRAG_START: 'dragstart',
  DRAGGING: 'dragging',
  DRAG_STOP: 'dragstop',
  ROTATE_START: 'rotatestart',
  ROTATING: 'rotating',
  ROTATE_STOP: 'rotatestop',
  CONTEXT_MENU: 'contextmenu',
};

export const CanvasMenuType = {
  CANVAS: 'canvas',
  ELEMENT: 'element',
};

export const ReportStudioSegmentEvents = {
  REPORT_STUDIO_SET_FILTER_EVENT: 'ReportStudioSetFilterEvent',
  REPORT_STUDIO_CLEAR_FILTER_EVENT: 'ReportStudioClearFilterEvent',
  REPORT_STUDIO_SET_DATE_FILTER_EVENT: 'ReportStudioSetDateFilterEvent',
  REPORT_STUDIO_TOGGLE_COMPARISON_DATA_EVENT: 'ReportStudioToggleComparisonDataEvent',
  REPORT_STUDIO_TOGGLE_FAVORITE_EVENT: 'ReportStudioToggleFavoriteEvent',
  REPORT_STUDIO_AI_SPARKLE_CLICK_EVENT: 'ReportStudioAISparkleClickEvent',
  REPORT_STUDIO_MOBILE_APP_CLICK_EVENT: 'ReportStudioMobileAppClickEvent',
};

export const ReportStudioCreatedFrom = {
  FREEHAND: 'freehand',
  DESIGN_TEMPLATE: 'design_template',
  REPORT_TEMPLATE: 'report_template',
};

export const ReportStudioMixinConstants = {
  THUMBNAIL_SESSION_KEY_PREFIX: 'reportstudio-template-thumbnail-',
  THUMBNAIL_NOT_FOUND_MESSAGE: 'Thumbnail not found for the Report Studio template id -',
};

export const ShortcutsEvents = {
  CANVAS_OPTION_EVENT: 'canvas_option_event',
  ICON_EVENT: 'icon_event',
  IMAGE_EVENT: 'image_event',
  EXPORT_EVENT: 'export_event',
  WIDGET_EVENT: 'widget_event',
};

export const OverflowStyles = {
  INITIAL: 'initial',
  HIDDEN: 'hidden',
};

export const PageElementKeyEvents = {
  KEYUP: 'keyup',
  KEYDOWN: 'keydown',
};

export const FontWeight = {
  BOLD: 'bold',
};

export const FontStyle = {
  ITALIC: 'italic',
};

export const TextDecoration = {
  UNDERLINE: 'underline',
};

export const CanvasMouseEvents = {
  MOUSEMOVE: 'mousemove',
  MOUSEDOWN: 'mousedown',
  MOUSEUP: 'mouseup',
};

export const FilterMode = {
  WIDGET_FILTERS: 'widget_filters',
  GLOBAL_FILTERS: 'global_filters',
};

export function getFilterModeValues() {
  return [
    { key: FilterMode.WIDGET_FILTERS, value: i18n.$t('Widget') },
    { key: FilterMode.GLOBAL_FILTERS, value: i18n.$t('Report') },
  ];
}

export const FontType = {
  TAHOMA: 'tahoma',
  LATO: 'lato',
};

export function getFontTypeValues() {
  return [
    { key: FontType.TAHOMA, value: i18n.$t('Tahoma') },
    { key: FontType.LATO, value: i18n.$t('Lato') },
  ];
}

export const FilterType = {
  IN: 'in',
  NIN: 'nin',
};

export function getFilterTypeOptions() {
  return [
    { key: FilterType.IN, value: i18n.$t('Include') },
    { key: FilterType.NIN, value: i18n.$t('Exclude') },
  ];
}

export const ReportStudioWidgetElementEvents = {
  WIDGET_ELEMENT_ADDED: 'widget_element_added',
  WIDGET_ELEMENT_REMOVED: 'widget_element_removed',
};

export const DefaultColors = {
  PAGE_COLOR: '#ffffff',
};

export const PageAssignmentType = {
  DATA_CATEGORY: 'data_category',
  PRODUCT: 'product',
  NONE: null,
};

export const ReportStudioFormSteps = {
  STEP_EMAIL: 'email',
  STEP_MAIN: 'main',
};

export const AlignmentGuideType = {
  // eslint-disable-next-line tap/no-raw-text-js
  VERTICAL: 'vertical',
  // eslint-disable-next-line tap/no-raw-text-js
  HORIZONTAL: 'horizontal',
};
